import { transparencyColors } from '@Components/BigBrowse/GridCardMesh/gridCardConstants';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { observer } from 'mobx-react-lite';

import type { GridCardMeshProps } from '../GridCardMesh2';
import { ProductCardRounded } from '../primitives/ProductCardRounded';

export const MultiSectionProduct = observer(function MultiSectionProduct({
  item,
  onClick,
}: GridCardMeshProps<
  | PlaneTypes.Card_MultiSection_Product
  | PlaneTypes.Card_SingleSectionView_Product
>) {
  return (
    <ProductCardRounded
      uniqueKey={item.key!}
      position={item.worldPosition}
      size={item.size.width}
      imageUrl={item.data?.imageUrl}
      transparencyColor={transparencyColors[item.type]}
      onClick={onClick}
    />
  );
});
